import { render } from "./MyAccountSecurityPage.vue?vue&type=template&id=723d05a6"
import script from "./MyAccountSecurityPage.vue?vue&type=script&lang=js"
export * from "./MyAccountSecurityPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__